var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("font-size:" + _vm.fontSize + "px"))},[_vm._v(_vm._s(this.$slots.default[0].text))])}
var staticRenderFns = []

export { render, staticRenderFns }